export function redirectAbsolutePath(path, replace = false) {
  // polyfill location.origin for IE
  if (!window.location.origin) {
    const port = window.location.port ? `:${window.location.port}` : ''
    window.location.origin = `${window.location.protocol}//${window.location.hostname}${port}`
  }

  const newUrl = window.location.origin + path
  if (replace) {
    window.location.replace(newUrl)
  } else {
    window.location.href = newUrl
  }
}



/** WEBPACK FOOTER **
 ** ./src/utils/redirect/redirect.js
 **/